<template>
	<div id="share">
		<h2>File Share</h2>

		<div class="input-group">
			<input class="form-control" type="file" @change="onFileChanged" />
			<button class="form-control btn btn-primary" v-on:click="upload">
				Upload
			</button>
		</div>

		<div class="col-12" v-if="fileList[0]" style="margin-top: 15px;">
			<h2>Uploaded files:</h2>
			<div>
				<span class="col-4">User</span>
				<span class="col-4">Filename/Download</span>
				<span class="col-4">Delete?</span>
			</div>
			<div v-for="file in fileList" v-bind:key="file.hash">
				<span class="col-4" style="color: green;">{{ file.user }}</span>
				<a
					class="col-4"
					target="_blank"
					:href="resultBaseURL + file.user + '/' + file.hash + '/' + file.name"
					>{{ file.name }}</a
				>
				<span
					class="col-4"
					v-on:click="delete_file(file)"
					style="color: red; cursor: pointer;"
					>Delete</span
				>
			</div>
		</div>
	</div>
</template>

<script>
import * as share_api from '@/api/share';

export default {
	name: 'Share',
	data: function() {
		return {
			resultBaseURL: 'https://share.zipixx.com/',
			formDataFieldName: 'file',
			formData: null,
			fileList: []
		};
	},
	methods: {
		upload: function() {
			share_api
				.upload_file(this.formData)
				.then(res => {
					alert('upload request success');
					if (this.fileList.indexOf(res.data) === -1) {
						this.fileList.push(res.data);
					}
					//this.fileList.push(this.store.getters.username + '_' + this.formData[0]);
					//console.log(this.formData.get());
				})
				.catch(error => {
					alert('upload request failed');
				});
		},
		delete_file: function(file) {
			share_api
				.delete_file(file.user, file.hash, file.name)
				.then(res => {
					//alert('delete request success');
					var index = this.fileList.indexOf(file);
					if (index > -1) {
						this.fileList.splice(index, 1);
					}
				})
				.catch(error => {
					alert('delete request failed');
				});
		},
		onFileChanged(event) {
			var files = event.target.files || event.dataTransfer.files;
			if (!files.length) {
				return;
			}
			var formData = new FormData();
			formData.append(this.formDataFieldName, files[0]);
			this.formData = formData;
		}
	},
	created: function() {
		share_api
			.get_file_list()
			.then(res => {
				this.fileList = res.data.files;
			})
			.catch(error => {
				//alert(error.response.status + ' ' + error.response.data);
				this.$store.commit('setUser', null);
			});
	}
};
</script>

<style scoped>
#share {
	margin: 0 auto;
	margin-top: 25px;
	max-width: 650px;
}
</style>
